import styled from "styled-components"
import { StyleableLink } from "../Sidebar"

export const Toolbar = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: ${props => (props.secondary ? 0 : 1)}px solid
    ${props => props.theme.secondary};
  padding: ${props => (props.secondary ? 1 : 0)}rem 0
    ${props => (props.secondary ? 0 : 1)}rem 0;
  align-items: center;
  min-height: ${props => (props.secondary ? 2 : 3.6)}rem;

  & > * {
    margin: 0 1rem 0 0;
    &:last-child {
      margin-right: 0;
    }
  }
`

export const PriorLink = styled(StyleableLink)`
  font-size: 2rem;
  line-height: 1.5rem;
  padding: 0;
  color: ${props => props.theme.accent};
  text-decoration: none;

  &::after {
    margin-left: 1rem;
    content:'•';
    font-size: 1.5rem;
    font-weight: normal;
    line-height: 1.5rem;
    padding: 0 0.5em;
    display-inline: block;
    opacity: 0.45;
    color: ${props => props.theme.secondary};
  }
`

export const Heading = styled.h1`
  font-size: ${props => (props.secondary ? 1.5 : 2)}rem;
  line-height: 1.5rem;
  padding: 0;
  color: ${props => props.theme.backgroundGradientDark};
`

export const SearchField = styled.input`
  flex-grow: 1;
  border: 1px solid ${props => props.theme.secondary};
  padding: 0.5rem;
  min-height: 2rem;
`



// WEBPACK FOOTER //
// ./src/UI/Toolbar/index.js